<template>
    <div>
        <p class="mdui-typo">
            互联网ICP备案：
            <a href="http://beian.miit.gov.cn/" target="_blank">
                苏ICP备17039737号-3
            </a> |
            <a target="_blank" class="gwab" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32030302000815" >
                <i></i>
                苏公网安备 32030302000815号
            </a>
            <br>
            <a href="https://yys.163.com" target="_blank">
                网易公司</a>版权所有 ©1997-2019 | 翻译来源 ©
            <a href="http://bbs.ngacn.cc/read.php?tid=10070310" target="_blank">psychosun@NGA
            </a>
            <br>Powered by
            <a href="https://www.mdui.org/" target="_blank">
                MDUI
            </a> | Made by
            <a href="https://space.bilibili.com/32725934" target="_blank">
                白云无尽_x64
            </a>
            <br>
        </p>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
    .gwab {
        position: relative;
        padding-left: 25px;
    }
    .gwab i {
        position: absolute;
        left: 0;
        top: 0;
        width: 20px;
        height: 20px;
        background: url(/static/img/gwab-icon.png) no-repeat;
    }



</style>


// WEBPACK FOOTER //
// src/components/Footer.vue